import React from "react";
import {
  Collapse,
  ControlGroup,
  Tag,
  EditableText,
  Card,
  Elevation,
} from "@blueprintjs/core";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import Diagnosis from "./Diagnosis";
import { apiCallPost } from "../../fns/util";
import cogoToast from "cogo-toast";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import ClinicalEntity from "../templates/ClinicalEntity";
import { generateMasterVisitEntities } from "../turbo/masterVisitEntities";
import ReactQuill from "react-quill";

class DischargeNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      searching: false,
      searchResults: [],
      changedText: false,
      text: this.props.data.dischargeFreeText
        ? this.props.data.dischargeFreeText
        : "",
    };
  }

  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxDischargeTemplateMaster/search`,
        { prefix: string }
      );

      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.setState({ collapse: !this.state.collapse })}
        >
          Discharge Template
        </Tag>
        <AsyncSelWrap
          placeholder="Templates..."
          searching={this.state.searching}
          items={this.state.searchResults.map((each) => {
            return {
              ...each,
              item: each.entityName,
              helper: each.anatomicalPart,
            };
          })}
          selectedItem={null}
          update={(item) => this.search(item)}
          onChange={(item) => {
            this.setState({ text: item.content, changedText: true });
          }}
        />
      </ControlGroup>
    );
  };
  normalizeQuillContent = (content) => {
    console.log("Before normalization:", content);
    // Remove extra line breaks at the start and end
    content = content.replace(/^(<p><br><\/p>)+|(<p><br><\/p>)+$/g, "");
    // Replace multiple consecutive <br> tags with a single one
    content = content.replace(/(<br\s*\/?>){2,}/gi, "<br>");
    // Remove empty paragraphs
    content = content.replace(/<p>\s*<\/p>/g, "");
    console.log("After normalization:", content);
    return content.trim();
  };
  handleChange = (value) => {
    // const normalizedValue = this.normalizeQuillContent(value);
    // console.log("Normalized value:", normalizedValue);
    this.setState({
      text: value,
      changed: true,
      changedText: true,
    });
    this.props.onUpdate({
      dischargeFreeText: value,
    });
  };
  renderDischargeTemplate = () => {
    return (
      <ReactQuill
        style={{ height: "150px", marginBottom: "50px" }}
        theme="snow"
        value={
          this.state.changedText
            ? this.state.text
            : this.state.changed
            ? this.props.data.content
            : this.props.data.dischargeFreeText
        }
        onChange={(val) => {
          this.handleChange(val);
        }}
        preserveWhitespace={true}
        // theme="snow"
        // value={this.state.loadedTemplate.content}
        // onChange={(val) => {
        //   this.setState({
        //     loadedTemplate: {
        //       ...this.state.loadedTemplate,
        //       content: val,
        //     },
        //     changed: true,
        //   });
        // }}
        modules={{
          clipboard: {
            matchVisual: false,
          },
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["link", "image"],
            ["clean"],
          ],
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "list",
          "bullet",
          "indent",
          "link",
          "image",
        ]}
      />
    );
  };
  render() {
    return (
      <Card
        style={{ padding: "0px", background: "none" }}
        elevation={Elevation.FOUR}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            justifyContent: "left",
            padding: "10px",
          }}
        >
          {this.renderHeading()}
          <Collapse isOpen={this.state.collapse}>
            {this.renderDischargeTemplate()}
          </Collapse>
        </div>
      </Card>
    );
  }
}

export default inject("authStore")(observer(DischargeNotes));
